import { MatDialog, MatDialogConfig, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Injectable, Inject, forwardRef, Type, Output } from '@angular/core';
import { Component } from '@angular/core';
import { EventEmitter } from '@angular/core';



@Injectable()
export class CardConfirmService {
    
    private confirmComponentType: Type<any>;
    public programAlias : string;

    constructor( @Inject(forwardRef(() => MatDialog)) private dialog: MatDialog) {
    }    

    setConfirmComponentType(componentType: Type<any>) {
        this.confirmComponentType = componentType;
    }    

    ProgramAlias(alias: string) {
        this.programAlias = alias;
    }   

    openCardConfirmDialog(title: string, html: string, onConfirm: () => void, onCancel: () => void) {
        let dialog = this.dialog.open(this.confirmComponentType, <MatDialogConfig>{
        });        
        dialog.componentInstance.html = html;
        dialog.componentInstance.title = title;
        var isCancel : boolean = true;
        dialog.componentInstance.confirm.subscribe((e) => {
            isCancel = false;
            if (e) {                
                onConfirm();
            } else {                
                onCancel();
            }
        });
        dialog.beforeClose().subscribe(() => {
            if (isCancel) {
                onCancel();
          }});
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/services/card-confirm.service.ts